import { useMemo } from 'react';
import { useIsDealershipPage } from '~/context/dealership/StaticContext';
import {
  useIsCampaignTemplateOne,
  useIsCampaignTemplateThree
} from '~/context/vdp/StaticContext';
import useTrackRendered from '~/hooks/common/telemetry/useTrackRendered';
import useScrollPosition from '~/hooks/vdp/cta/useScrollPosition';
import useIsNotAvailableForImmediatePurchase from '~/hooks/vdp/selectors/useIsNotAvailableForImmediatePurchase';
import useWhyBuyData from '~/hooks/vdp/selectors/useWhyBuyData';
import useHasMappedWhyBuyFeatures from '~/hooks/vdp/useHasMappedWhyBuyFeatures';
import useShowWhyBuyContent from '~/hooks/vdp/useShowWhyBuyContent';
import { hasWhyBuyStockImagery } from '~/utilities/vdp/whyBuyAnalytics';

const EXPERIMENT = 'car-merch-ui-vdp-why-buy-imagery';
const SCROLL_DEPTH = 420;
const DEEP_SCROLL_DEPTH = 1400;
const CAMPAIGN_TEMPLATE_THREE_DEPTH = 1700;

export default function useTrackWhyBuyImageryRendered(): void {
  const { bulletPoints } = useWhyBuyData();
  const hasMappedFeatures = useHasMappedWhyBuyFeatures();
  const isCampaignTemplateOne = useIsCampaignTemplateOne();
  const isCampaignTemplateThree = useIsCampaignTemplateThree();
  const isDealershipPage = useIsDealershipPage();
  const isNotAvailableForImmediatePurchase =
    useIsNotAvailableForImmediatePurchase();
  const scrollPosition = useScrollPosition();
  const showWhyBuyContent = useShowWhyBuyContent();

  const isWhyBuyImageryRendered =
    showWhyBuyContent &&
    hasMappedFeatures &&
    !isCampaignTemplateOne &&
    !isDealershipPage;
  const scrollDepth = isCampaignTemplateThree
    ? CAMPAIGN_TEMPLATE_THREE_DEPTH
    : isNotAvailableForImmediatePurchase
    ? DEEP_SCROLL_DEPTH
    : SCROLL_DEPTH;
  const hasStockImagery = hasWhyBuyStockImagery(bulletPoints);
  const customAttributes = useMemo(
    () => ({ hasStockImagery }),
    [hasStockImagery]
  );

  useTrackRendered(
    EXPERIMENT,
    isWhyBuyImageryRendered && scrollPosition >= scrollDepth,
    customAttributes
  );
}
